// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate'

import App from './App'
import router from './router'
import '@/maklik'
import '@/validation'

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  duration: 600,
  ease: 'ease-in-out',
  offset: -36
})

Vue.use(VeeValidate, {
  events: 'blur|change',
  inject: false
})

/* eslint-disable no-new */
new Vue({
  el: '#root',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    // Render event for Webpack prerender-spa-plugin
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js